<!-- #27 -->
<template>
  <v-col>
    <v-data-table
      v-model="selectedUsers"
      :headers="headers"
      :items="users"
      :options.sync="options"
      :server-items-length="total"
      :search="search"
      :loading="usersLoader"
      class="elevation-1"
      item-key="id"
      show-select
      :items-per-page="25"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:item.data-table-select="{ item }">
        <v-checkbox
          v-if="item.is_sudo_user === 0"
          :input-value="isItemSelected(item)"
          @click.stop="handleSelect(item, isItemSelected(item))"
        ></v-checkbox>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Users</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2 mr-2" @click="addUser(0)">
            Add User
          </v-btn>

          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, i) in allUserStatuses"
                :key="i"
                @click="openConfirm(item)"
              >
                <v-list-item-title
                  >{{ item.text }} Selected Accounts</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
        <v-divider class="mt-1 mb-4"></v-divider>

        <v-form>
          <v-row class="custom-row pl-5 pr-5 mb-1">
            <v-col cols="12" sm="3">
              <v-text-field label="Name" v-model="name" outlined></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                label="Email"
                v-model="email"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="group"
                label="Group"
                item-text="name"
                item-value="name"
                hide-no-data
                :items="groupsList"
                outlined
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="statusUser"
                label="Status"
                item-text="text"
                hide-no-data
                item-value="value"
                :items="statuses"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="user_category"
                label="User Category"
                item-text="value"
                item-value="id"
                hide-no-data
                :items="userTypes"
                outlined
                @change="fetchGroups()"
              ></v-autocomplete>
            </v-col>
            <v-col v-if="user_category === 1" cols="12" sm="3">
              <v-autocomplete
                v-model="client_id"
                :items="clients"
                :loading="clientLoader"
                hide-no-data
                item-text="name"
                item-value="id"
                outlined
                label="Select client"
                placeholder="Start typing to Search"
              ></v-autocomplete>
            </v-col>
            <v-col v-if="user_category === 2">
              <v-autocomplete
                v-model="seller_id"
                :items="sellers"
                :loading="sellerLoader"
                hide-no-data
                item-text="name"
                item-value="id"
                label="Select Seller"
                placeholder="Start typing to Search"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col v-if="user_category === 4" cols="12" sm="3">
              <v-autocomplete
                v-model="warehouse"
                :items="warehousees"
                :loading="sellerWarehouse"
                hide-no-data
                item-text="name"
                item-value="id"
                label="Select Warehouse"
                placeholder="Start typing to Search"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col v-if="user_category === 5" cols="12" sm="3">
              <v-autocomplete
                label="Vendor Name"
                :items="vendors"
                v-model="selectedVendor"
                item-text="vendor_name"
                item-value="id"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col v-if="user_category === 6" cols="12" sm="3">
              <v-autocomplete
                v-model="ops_warehouse"
                :items="opswarehouses"
                :loading="sellerLoader"
                item-text="name"
                item-value="id"
                label="Select Ops Warehouse"
                placeholder="Start typing to Search"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col v-if="user_category === 6" cols="12" sm="3">
              <v-autocomplete
                v-model="warehouse_facility"
                :items="warehousees"
                :loading="sellerWarehouse"
                hide-no-data
                item-text="name"
                item-value="id"
                multiple
                label="Select Warehouse Facility"
                placeholder="Start typing to Search"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              :class="[
                user_category === 1 ||
                user_category == 2 ||
                user_category == 4 ||
                user_category == 5
                  ? 'offset-md-3'
                  : user_category == 6
                  ? ''
                  : 'offset-md-6',
              ]"
            >
              <v-btn color="white" @click="clearAll" style="float: right"
                >Clear</v-btn
              >
              <v-btn
                color="primary"
                class="success mr-5"
                @click="searchAll"
                style="float: right"
                >Search</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="mb-5"></v-divider>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip
          class="ma-1"
          :color="
            item.status === 'active'
              ? 'success'
              : item.status === 'suspend'
              ? 'warning'
              : 'error'
          "
        >
          {{ item.status | ucfirst }}
        </v-chip>
      </template>
      <template v-slot:[`item.groups`]="{ item }">
        <v-chip class="ma-1" v-for="s in item.groups" :key="s.id">
          {{ s.name }}
        </v-chip>
      </template>
      <template v-slot:[`item.user_category_name`]="{ item }">
        {{ category(item.user_category_name, item) }}
      </template>
      <template v-slot:[`item.last_login`]="{ item }">
        {{ item.last_login || localMoment | moment("DD MMM, YYYY hh:mm A") }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="item.is_sudo_user === 0"
          >
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="inviteUser(item)"
            >
              mdi-email
            </v-icon>
          </template>
          <span>Send Invitation</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="item.is_sudo_user === 0"
          >
            <v-icon
              small
              class="ml-2"
              v-bind="attrs"
              v-on="on"
              @click="addUser(item.id)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <ConfirmDialog
      :dialog="dialogConfirm"
      :text="'Are you sure you want to ' + action.text + ' selected accounts?'"
      :loader="statusLoader"
      @confirm="confirmAction"
      @close="closeConfirm"
    />
    <ConfirmDialog
      :dialog="dialogInvite"
      text="Are you sure want to send invitation email?"
      :loader="inviteLoader"
      @confirm="sendInvite"
      @close="dialogInvite = false"
    />
  </v-col>
</template>
<script>
import { userStatuses } from "@/config/data";
import { mapActions, mapGetters } from "vuex";
import ConfirmDialog from "@/components/front/common/ConfirmDialog";

export default {
  components: {
    ConfirmDialog,
  },
  computed: {
    ...mapGetters(["userTypes"]),
    allUserStatuses() {
      delete userStatuses.delete;
      return Object.keys(userStatuses).map((i) => {
        return {
          text: userStatuses[i],
          value: i,
        };
      });
    },
  },
  data: () => ({
    ops_warehouse: "",
    opswarehouses: [],
    selectedVendor: "",
    statusUser: "",
    groupsList: [],
    dialogConfirm: false,
    statusLoader: false,
    searchOptions: [
      {
        text: "Name / Email",
        value: "",
      },
      {
        text: "Group",
        value: "group_access",
      },
      {
        text: "Category",
        value: "user_category",
      },
    ],
    searchType: "",
    statuses: [
      {
        text: "Active",
        value: "active",
      },
      {
        text: "Delete",
        value: "delete",
      },
      {
        text: "Suspend",
        value: "suspend",
      },
    ],

    headers: [
      {
        text: "Name",
        value: "name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Email",
        value: "email",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Account Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Last Active",
        value: "last_login",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Group Access",
        value: "groups",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "User Category",
        value: "user_category_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Actions",
        value: "actions",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
    ],
    users: [],
    options: {},
    total: 0,
    selectedUsers: [],
    usersLoader: false,
    search: null,
    action: {},
    _timerId: null,
    dialogInvite: false,
    inviteLoader: false,
    editedIndex: -1,
    editedItem: {
      id: 0,
      name: "",
      email: null,
    },
    user_category: null,
    name: "",
    group: "",
    sellers: [],
    clients: [],
    warehousees: [],
    vendors: [],
    selectAll: false,
    warehouse_facility: null,
  }),

  watch: {
    options: {
      handler() {
        if (this.$route.params.id && this.options.page === 1) return;
        this.fetchMembers();
      },
      deep: true,
    },
    search() {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        if (this.search !== "" && this.search !== null) this.fetchMembers();
      }, 300);
    },
    searchType() {
      if (this.search !== "" && this.search !== null) this.fetchMembers();
    },
  },
  async created() {
    if (this.$route.params.id) {
      await this.fetchClientList();
      this.client_id = this.$route.params.id;
      this.statusUser = "active";
      this.user_category = 1;
      this.searchAll();
    }
    this.getUserTypes();
    this.fetchMemberGroups();
  },
  methods: {
    ...mapActions([
      "getMembers",
      "createMember",
      "updateMember",
      "deleteMember",
      "changeMemberStatus",
      "sendUserInvite",
      "snackBar",
      "fetchClient",
      "getUserTypes",
      "getSellersActiveList",
      "getRSAUserGroupdropdown",
      "fetchStorelist",
      "getvendorDropdown",
      "getInforWarehouseList",
    ]),
    isItemSelected(item) {
      return this.selectedUsers.some(
        (selectedItem) => selectedItem.id === item.id
      );
    },
    handleSelect(item) {
      const isSelected = this.isItemSelected(item);
      if (isSelected) {
        this.selectedUsers = this.selectedUsers.filter(
          (selectedItem) => selectedItem.id !== item.id
        );
      } else {
        this.selectedUsers.push(item);
      }
    },

    onHeaderCheckboxClick() {
      this.selectAll = !this.selectAll; // Toggle the header checkbox state
      this.users.forEach((item) => {
        this.$set(item, "selected", this.selectAll);
      });
    },
    clearAll() {
      this.name = null;
      this.email = null;
      this.group = null;
      this.user_category = null;
      this.client_id = null;
      this.seller_id = null;
      this.filtersArr = [];
      this.statusUser = null;
      this.warehouse = null;
      this.selectedVendor = null;
      this.ops_warehouse = null;
      this.warehouse_facility = [];
      this.fetchMembers();
    },
    getvendorList() {
      if (this.vendors.length) return;

      this.vendorLoader = true;

      this.getvendorDropdown()
        .then((res) => {
          this.vendorLoader = false;
          this.vendors = res.data;
        })
        .catch(() => {
          this.vendorLoader = false;
        });
    },
    allFilters() {
      this.orderLoader = true;
      if (this.user_category == 3) {
        this.client_id = null;
        this.seller_id = null;
        this.selectedVendor = null;
        this.warehouse = null;
      }
      if (this.user_category == 4) {
        this.client_id = null;
        this.seller_id = null;
        this.selectedVendor = null;
      }
      if (this.user_category == 5) {
        this.client_id = null;
        this.seller_id = null;
        this.warehouse = null;
      }
      if (this.user_category == 1) {
        this.seller_id = null;
        this.warehouse = null;
        this.selectedVendor = null;
      }

      let obj = {
        name: this.name,
        email: this.email,
        group_ids: this.group,
        user_category: this.user_category,
        clientid: this.client_id,
        sellerid: this.seller_id,
        status: this.statusUser,
        warehouse: this.warehouse,
        vendorid: this.selectedVendor,
        ops_warehouse: this.ops_warehouse,
        warehouse_facility: this.warehouse_facility
          ? this.warehouse_facility.join(",")
          : "",
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    async searchAll() {
      this.options.page = 1;
      await this.allFilters();
      await this.fetchMembers();
    },

    fetchMemberGroups() {
      this.groupsList = [];
      this.groupsLoader = true;

      this.getRSAUserGroupdropdown({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.groupsLoader = false;
          this.groupsList = res.data;
        })
        .catch(() => {
          this.groupsLoader = false;
        });
    },
    fetchClientList() {
      if (this.clients.length > 0) return;
      this.clientLoader = true;
      this.fetchClient({
        fields: "id,name",
        pagination: 0,
        active: this.user_category,
      })
        .then((res) => {
          this.clientLoader = false;
          this.clients = res.data;
        })
        .catch(() => {
          this.clientLoader = false;
        });
    },
    fetchWarehouse() {
      this.fetchStorelist().then((res) => {
        this.storers = res.data.storer;
        this.warehousees = res.data.warehouses.map(
          (obj) => Object.keys(obj)[0]
        );
      });
    },
    fetchSellerList() {
      if (this.sellers.length > 0) return;
      this.sellerLoader = true;
      this.getSellersActiveList({
        // client_id: this.userData.client_id,
        params: {
          fields: "id,name",
          pagination: 0,
          // active: this.userData.user_category,
        },
      })
        .then((res) => {
          this.sellerLoader = false;
          this.sellers = res.data;
        })
        .catch(() => {
          this.sellerLoader = false;
        });
    },
    fetchGroups() {
      if (this.user_category == 1) {
        this.fetchClientList();
      } else if (this.user_category == 2) {
        this.fetchSellerList();
      } else if (this.user_category == 4) {
        this.fetchWarehouse();
      } else if (this.user_category == 5) {
        this.getvendorList();
      } else if (this.user_category == 6) {
        this.fetchWarehouse();
        if (this.opswarehouses.length == 0) {
          this.getInforWarehouseList().then((response) => {
            this.opswarehouses = response.data.result;
          });
        }
      }
    },
    fetchMembers() {
      this.users = [];
      this.usersLoader = true;
      this.getMembers({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.usersLoader = false;
          this.users = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.usersLoader = false;
        });
    },

    addUser(id) {
      this.$router.push({
        name: "UserCreate",
        params: {
          id: id,
        },
      });
    },

    openConfirm(action) {
      if (this.selectedUsers.length === 0) {
        return this.snackBar({
          color: "error",
          message: "Please select atleast one user",
        });
      }
      this.action = action;
      this.dialogConfirm = true;
    },

    closeConfirm() {
      this.dialogConfirm = false;
    },

    confirmAction() {
      this.statusLoader = true;
      this.changeMemberStatus({
        action: this.action.value,
        data: { user_ids: this.selectedUsers.map((i) => i.id) },
      })
        .then((res) => {
          this.statusLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.dialogConfirm = false;
          this.selectedUsers = [];
          this.fetchMembers();
        })
        .catch(() => {
          this.statusLoader = false;
          this.closeConfirm();
        });
    },

    inviteUser(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogInvite = true;
    },

    sendInvite() {
      this.inviteLoader = true;
      this.sendUserInvite({
        user_ids: [this.editedItem.id],
      })
        .then((res) => {
          this.inviteLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.dialogInvite = false;
        })
        .catch(() => {
          this.inviteLoader = false;
        });
    },
    category(type, item) {
      if (type == "Seller") {
        if (item.seller_name !== null && item.seller_name !== "") {
          return `Seller (${item.seller_name})`;
        } else {
          return type;
        }
      } else if (type == "Client") {
        if (item.client_name !== null && item.client_name !== "") {
          return `Client (${item.client_name})`;
        } else {
          return type;
        }
      } else if (type == "PAS") {
        if (
          item.warehouse !== null &&
          item.warehouse !== "" &&
          item.warehouse.length > 0
        ) {
          return `PAS (${item.warehouse.join(", ")})`;
        } else {
          return type;
        }
      } else if (type == "VENDOR") {
        if (item.vendor_name !== null && item.vendor_name !== "") {
          return `VENDOR (${item.vendor_name})`;
        } else {
          return type;
        }
      } else if (type == "RSAOPS") {
        if (
          item.warehouse !== null &&
          item.warehouse !== "" &&
          item.warehouse.length > 0 &&
          item.warehouse_facility !== null &&
          item.warehouse_facility !== "" &&
          item.warehouse_facility.length > 0
        ) {
          return `RSAOPS (${item.warehouse.join(
            ", "
          )}) , (${item.warehouse_facility.join(", ")})`;
        } else {
          return type;
        }
      } else {
        return type;
      }
    },
  },
};
</script>
